import React, { Component, Fragment } from "react";
import MenuSTI from "../Dashboard/Elementos/MenuSTI";
import NomeUnidade from "../../UI/NomeUnidade";

export default class FrameBI extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            unidade: "Todas",
        }
    }

    render() {
        return (
            <Fragment>

                <NomeUnidade unidade={"Relatórios STI"}/>

                <div className="content">

                    <div className="col-md-12">
                        <MenuSTI />
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <iframe src="http://paineis.observatoriopb.com.br/dash/sigemsti" scrolling="no" allowfullscreen="true" style={{ width: '100%', height: '80vh', border: 'none' }}></iframe>
                        </div>
                    </div>

                </div>

            </Fragment>
        )
    }
}